module.exports = __webpack_public_path__ + "img/ring_g_skip_1_1@3x.146fe4ec.png";